import { render } from "./SuperAdminSMSAndEmailSetting.vue?vue&type=template&id=303a2dc2&scoped=true"
import script from "./SuperAdminSMSAndEmailSetting.vue?vue&type=script&lang=js"
export * from "./SuperAdminSMSAndEmailSetting.vue?vue&type=script&lang=js"

import "./SuperAdminSMSAndEmailSetting.vue?vue&type=style&index=0&id=303a2dc2&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-303a2dc2"]])

export default __exports__